<button type="button"
        onclick="this.parentElement.querySelector('input').stepDown();this.parentElement.querySelector('input').dispatchEvent(new Event('input', {
                    bubbles: true,
                }))">-</button>
<input type="number"
       [min]="step?? 1"
       [step]="step?? 1"
       name="quantity"
       onblur="this.value = +this.value === NaN || +this.value < +this.step ? this.step : (+this.value % +this.step === 0 ? this.value : (+this.value + +this.value % +this.step))"
       (keypress)="pressedNumber($event)"
       (paste)="pastedNumber($event,step)"
       (input)="setQuantity()"
       [value]="quantity ?? 1">
<button type="button"
        onclick="this.parentElement.querySelector('input').stepUp();this.parentElement.querySelector('input').dispatchEvent(new Event('input', {
                    bubbles: true,
                }))">+</button>
